import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSubscription } from '../contexts/SubscriptionContext';

const TrialGuard = ({ children }) => {
  const { isTrialExpired, loading } = useSubscription();

  if (loading) {
    return (
      <div className="min-h-screen bg-primary-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (isTrialExpired()) {
    return <Navigate to="/app/subscription" replace />;
  }

  return children;
};

export default TrialGuard; 